/**
 * Labels and config for store details sections (API-driven sections).
 * Keeps presentation logic out of components (Clean Architecture).
 */

export const STORE_SECTION_FIELD_LABELS: Record<string, string> = {
  id: 'المعرف',
  name: 'الاسم',
  status: 'الحالة',
  address: 'العنوان',
  city: 'المدينة',
  region: 'المنطقة',
  area: 'المنطقة',
  paymentStatus: 'حالة الدفع',
  quantityAvailable: 'الكمية المتاحة',
  lowStockThreshold: 'حد المخزون المنخفض',
  lastVisit: 'آخر زيارة',
  lastPaymentDate: 'تاريخ آخر دفع',
  totalDue: 'المبلغ المستحق',
  totalPaid: 'المبلغ المدفوع',
  latitude: 'خط العرض',
  longitude: 'خط الطول',
  managerName: 'مدير المتجر',
  phoneNumber: 'رقم الهاتف',
  commercialRegisterNumber: 'رقم السجل التجاري',
  commercialRegisterImage: 'صورة السجل التجاري',
  taxCardNumber: 'رقم البطاقة الضريبية',
  taxCardImage: 'صورة البطاقة الضريبية',
  profileImageUrl: 'الصورة الشخصية',
  images: 'الصور'
};

/** Keys to skip when rendering generic section data (handled by dedicated blocks) */
export const STORE_SECTION_SKIP_KEYS = new Set([
  'profileImageUrl',
  'images',
  'commercialRegisterImage',
  'taxCardImage',
  'geo_location'
]);

export function formatSectionValue(value: unknown): string {
  if (value === null || value === undefined) return '—';
  if (typeof value === 'boolean') return value ? 'نعم' : 'لا';
  if (typeof value === 'object' && !Array.isArray(value)) return JSON.stringify(value);
  return String(value);
}

/** Filter section data entries for generic display (excludes skip keys and empty values) */
export function getSectionDataEntries(data: Record<string, unknown> | null | undefined): [string, unknown][] {
  if (!data || typeof data !== 'object') return [];
  return Object.entries(data).filter(
    ([key, value]) =>
      !STORE_SECTION_SKIP_KEYS.has(key) &&
      value !== undefined &&
      value !== null &&
      value !== ''
  );
}
